import { render } from "./Walk.vue?vue&type=template&id=2050fc60&scoped=true&bindings={\"skipWalkthrough\":\"options\"}"
import script from "./Walk.vue?vue&type=script&lang=js"
export * from "./Walk.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2050fc60"

export default script